import {
  BaseMsg,
  Msg,
  MsgExecute,
  type Account,
  type TxResult,
} from "rujira.js";

import type { PreparedV2Execution } from "./operations";

export class MsgV2DirectExecute extends BaseMsg implements Msg {
  private prepared?: Promise<PreparedV2Execution>;

  constructor(
    public readonly account: Account,
    private readonly proxyContract: string,
    private readonly prepare: () => Promise<PreparedV2Execution>,
    private readonly afterBroadcast?: (result: TxResult) => Promise<void>,
    private readonly assertCurrent?: () => void
  ) {
    super();
  }

  private execution(): Promise<PreparedV2Execution> {
    this.prepared ??= this.prepare();
    return this.prepared;
  }

  async toCosmosTx() {
    this.assertCurrent?.();
    const execution = await this.execution();
    this.assertCurrent?.();
    return new MsgExecute(
      this.account,
      execution.funds,
      this.proxyContract,
      execution.msg
    ).toCosmosTx();
  }

  async broadcasted(result: TxResult): Promise<void> {
    await this.afterBroadcast?.(result);
  }
}
